import React, { useState } from 'react';
import './Projects.css';

const Projects: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const projects = [
    {
      id: 1,
      title: 'Modern Prefabrik Villa',
      category: 'villa',
      location: 'İstanbul',
      area: '250 m²',
      year: '2023',
      image: '/images/project-1.jpeg'
    },
    {
      id: 2,
      title: 'Prefabrik Ev Projesi',
      category: 'ev',
      location: 'Ankara',
      area: '180 m²',
      year: '2023',
      image: '/images/project-2.jpeg'
    },
    {
      id: 3,
      title: 'Kurumsal Ofis Yapısı',
      category: 'ofis',
      location: 'İzmir',
      area: '500 m²',
      year: '2023',
      image: '/images/project-3.jpeg'
    },
    {
      id: 4,
      title: 'Lüks Prefabrik Villa',
      category: 'villa',
      location: 'Bodrum',
      area: '320 m²',
      year: '2022',
      image: '/images/project-4.jpeg'
    },
    {
      id: 5,
      title: 'Endüstriyel Tesis',
      category: 'endustriyel',
      location: 'Bursa',
      area: '1200 m²',
      year: '2023',
      image: '/images/project-5.jpeg'
    },
    {
      id: 6,
      title: 'Konteyner Ev',
      category: 'konteyner',
      location: 'Antalya',
      area: '800 m²',
      year: '2022',
      image: '/images/project-6.jpeg'
    },
    {
      id: 7,
      title: 'Modern Aile Evi',
      category: 'ev',
      location: 'Kocaeli',
      area: '200 m²',
      year: '2023',
      image: '/images/hero-1.jpeg'
    },
    {
      id: 8,
      title: 'Özel Tasarım Villa',
      category: 'villa',
      location: 'Çeşme',
      area: '280 m²',
      year: '2023',
      image: '/images/hero-2.jpeg'
    }
  ];

  const categories = [
    { id: 'all', name: 'Tümü' },
    { id: 'ev', name: 'Evler' },
    { id: 'villa', name: 'Villalar' },
    { id: 'ofis', name: 'Ofisler' },
    { id: 'endustriyel', name: 'Endüstriyel' },
    { id: 'konteyner', name: 'Konteyner Evler' }
  ];

  const filteredProjects = selectedCategory === 'all' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory);

  return (
    <div className="projects-page">
      <section className="projects-hero">
        <div className="container">
          <h1 className="page-title">Projelerimiz</h1>
          <p className="page-subtitle">
            Gerçekleştirdiğimiz başarılı projelerimizi keşfedin. 
            Her proje, kalite ve müşteri memnuniyetinin bir göstergesidir.
          </p>
        </div>
      </section>

      <section className="projects-content section">
        <div className="container">
          <div className="filter-buttons">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>

          <div className="projects-grid">
            {filteredProjects.map((project) => (
              <div key={project.id} className="project-card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} loading="lazy" />
                  <div className="project-overlay">
                    <button className="project-view-btn">Detayları Gör</button>
                  </div>
                </div>
                <div className="project-info">
                  <h3 className="project-title">{project.title}</h3>
                  <div className="project-details">
                    <div className="project-detail-item">
                      <span className="detail-icon">📍</span>
                      <span>{project.location}</span>
                    </div>
                    <div className="project-detail-item">
                      <span className="detail-icon">📐</span>
                      <span>{project.area}</span>
                    </div>
                    <div className="project-detail-item">
                      <span className="detail-icon">📅</span>
                      <span>{project.year}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;

